import * as Sentry from "@sentry/react";
// Initialize Sentry before anything else
Sentry.init({
  dsn: "https://27eca9fe8459c8e49f2b3c905fc0de7d@o4510307623108608.ingest.us.sentry.io/4510307625009152",
  sendDefaultPii: true,
});
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
